export default "__VITE_ASSET__9c23f3e3__"